import React from 'react';
import { SectionHeading } from './SectionHeading';
import { ClipboardCheck, Lightbulb, Rocket, BarChart3 } from 'lucide-react';
const steps = [{
  icon: ClipboardCheck,
  title: '1. Audit',
  description: 'We analyze your current digital presence, identify gaps, and spot opportunities.'
}, {
  icon: Lightbulb,
  title: '2. Strategy',
  description: 'We build a custom roadmap tailored to your business goals and target audience.'
}, {
  icon: Rocket,
  title: '3. Execute',
  description: 'Our team implements the strategy with precision across all chosen channels.'
}, {
  icon: BarChart3,
  title: '4. Optimize',
  description: 'We continuously monitor performance and refine tactics to maximize ROI.'
}];
export function Process() {
  return <section id="process" className="py-20 bg-slate-900 text-white" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <SectionHeading title="How We Drive Growth" subtitle="Our Process" light={true} data-id="element-77" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16" data-id="element-78">
          {steps.map((step, index) => <div key={index} className="relative group" data-id="element-79">
              {/* Connector Line (Desktop only) */}
              {index < steps.length - 1 && <div className="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-slate-700 -z-10" data-id="element-80"></div>}

              <div className="flex flex-col items-center text-center" data-id="element-81">
                <div className="w-16 h-16 bg-slate-800 border-2 border-green-500 rounded-full flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(34,197,94,0.3)] group-hover:scale-110 transition-transform duration-300 bg-slate-900 z-10" data-id="element-82">
                  <step.icon className="w-8 h-8 text-green-400" data-id="element-83" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-84">{step.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed" data-id="element-85">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}